module.exports = __webpack_public_path__ + "static/media/01-start.17371edf.png";